import React from 'react'
import styles from './SwitchVoteModal.scss'
import {StyledModal} from 'common/StyledModal'
import {Button} from 'common/Button'
import widgetStyles from '../VoteWidget/VoteWidget.scss'
import cx from 'classnames'
import {VOTE_LIMIT} from '../../../../App/reducers/rolloutContest'

export class SwitchVoteModal extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      toReplace: null
    }
  }

  onSelectionChanged = (e) => {
    this.setState({toReplace: parseInt(e.target.value, 10)})
  }
  render () {
    const {onRequestClose, votedIds, reports, onReplace} = this.props
    const {toReplace} = this.state

    return (
      <StyledModal showModal
        maxWidth={450}
        onRequestClose={onRequestClose}>
        <div className={styles.SwitchVoteModal}>
          <h3>You have already submitted {VOTE_LIMIT} votes.</h3>
          <p>If you would like to vote for this report you can change one of your previous votes by selecting it below:</p>
          {votedIds.map(id => <label key={id}>
            <input type='radio' value={id} checked={toReplace === id} name='toReplace' onChange={this.onSelectionChanged} />
            <span>{reports.get(id).title}</span>
          </label>)}
          <div className={styles.buttons}>
            <Button
              className={cx(widgetStyles.voteButton, styles.voteButton, !toReplace && styles.disabled)}
              onClick={toReplace && (() => onReplace(toReplace))}>
              Replace Vote
            </Button>
            {' '}
            <a className={styles.cancelButton} onClick={onRequestClose}>Cancel</a>
          </div>
        </div>
      </StyledModal>
    )
  }
}
